import { put, call, takeLatest } from 'redux-saga/effects';
import { useHistory } from 'react-router-dom'
import {
    SHOW_LOADER,
    HIDE_LOADER,
    VULNERABILITY_MANAGEMENT_GET_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_GET_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_GET_LIST_REQUESTED,
    GET_VULNERABLITY_MANAGEMENT_BY_ID_REQUESTED,
    GET_VULNERABLITY_MANAGEMENT_BY_ID_SUCCESSED,
    GET_VULNERABLITY_MANAGEMENT_BY_ID_FAILED,
    VULNERABILITY_EXPORT_PDF_LIST_SUCCESSED,
    SET_FEEDBACK_ALERT,
    VULNERABILITY_EXPORT_PDF_LIST_FAILED,
    VUNERABILITY_EXPORT_EXCEL_LIST_SUCCESSED,
    VUNERABILITY_EXPORT_EXCEL_LIST_FAILED,
    VUNERABILITY_EXPORT_EXCEL_LIST_REQUESTED,
    VULNERABILITY_EXPORT_PDF_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_GET_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_GET_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_GET_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_DELETE_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_DELETE_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_DELETE_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_GENERATE_REPORTS_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_GENERATE_REPORTS_FAILED,
    VULNERABILITY_MANAGEMENT_TEMPLATE_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_TEMPLATE_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_GENERATE_REPORTS_REQUESTED,
    VULNERABILITY_MANAGEMENT_TEMPLATE_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_BULK_UPDATE_SUCCESSED,
    VULNERABILITY_MANAGEMENT_BULK_UPDATE_FAILED,
    VULNERABILITY_MANAGEMENT_BULK_UPDATE_REQUESTED,
    VULNERABILITY_MANAGEMENT_ATTACK_TYPE_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ATTACK_TYPE_FAILED,
    VULNERABILITY_MANAGEMENT_ASSET_TYPE_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSET_TYPE_FAILED,
    VULNERABILITY_MANAGEMENT_ATTACK_TYPE_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSET_TYPE_REQUESTED,
    VULNERABILITY_MANAGEMENT_SEVERITY_SUCCESSED,
    VULNERABILITY_MANAGEMENT_SEVERITY_FAILED,
    VULNERABILITY_MANAGEMENT_SEVERITY_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_LOGS_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_LOGS_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_LOGS_REQUESTED,
    VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_CREATE_SUCCESSED,
    VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_CREATE_FAILED,
    VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_UPDATE_SUCCESSED,
    VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_UPDATE_FAILED,
    VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_UPDATE_REQUESTED,
    VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_CREATE_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_UPDATE_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_UPDATE_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_UPDATE_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_ADD_ASSET_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ADD_ASSET_FAILED,
    VULNERABILITY_MANAGEMENT_ADD_ASSET_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSET_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_DELETE_ASSET_REQUESTED,
    VULNERABILITY_MANAGEMENT_DELETE_ASSET_SUCCESSED,
    VULNERABILITY_MANAGEMENT_DELETE_ASSET_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_APPLICATION_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_APPLICATION_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_APPLICATION_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_ACTIONS_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_ACTIONS_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_ACTIONS_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_EXECUTE_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_EXECUTE_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_EXECUTE_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_MULTI_DELETE_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_MULTI_DELETE_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_MULTI_DELETE_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_GET_SINGLE_ASSESSMENT_REQUESTED,
    VULNERABILITY_MANAGEMENT_GET_SINGLE_ASSESSMENT_SUCCESSED,
    VULNERABILITY_MANAGEMENT_GET_SINGLE_ASSESSMENT_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_ADD_VULNERABILITY_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_ADD_VULNERABILITY_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_VULNERABILITY_REQUESTED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_VULNERABILITY_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_VULNERABILITY_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_ADD_VULNERABILITY_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_IMPORT_FAILED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_IMPORT_SUCCESSED,
    VULNERABILITY_MANAGEMENT_ASSESSMENT_IMPORT_REQUESTED,
    UPDATE_PARTIAL_VULNERABILITY_MANAGEMENT_REQUESTED,
    UPDATE_PARTIAL_VULNERABILITY_MANAGEMENT_SUCCESSED,
    UPDATE_PARTIAL_VULNERABILITY_MANAGEMENT_FAILED,
    ADD_TASK_VULNERABILITY_MANAGEMENT_SUCCESSED,
    ADD_TASK_VULNERABILITY_MANAGEMENT_FAILED,
    ADD_TASK_VULNERABILITY_MANAGEMENT_REQUESTED,
    VIEW_TASK_VULNERABILITY_MANAGEMENT_REQUESTED,
    VIEW_TASK_VULNERABILITY_MANAGEMENT_SUCCESSED,
    VIEW_TASK_VULNERABILITY_MANAGEMENT_FAILED,
    VULNERABILITY_MANAGEMENT_COMMENT_SUCCESSED,
    VULNERABILITY_MANAGEMENT_COMMENT_FAILED,
    VULNERABILITY_MANAGEMENT_COMMENT_REQUESTED,
    VULNERABILITY_MANAGEMENT_UPLOAD_SUCCESSED,
    VULNERABILITY_MANAGEMENT_UPLOAD_FAILED,
    VULNERABILITY_MANAGEMENT_TEMPLATE_TYPE_SUCCESSED,
    VULNERABILITY_MANAGEMENT_TEMPLATE_TYPE_FAILED,
    VULNERABILITY_MANAGEMENT_TEMPLATE_TYPE_REQUESTED,
    VULNERABILITY_MANAGEMENT_UPLOAD_NESSUS_SUCCESSED,
    VULNERABILITY_MANAGEMENT_UPLOAD_NESSUS_FAILED,
    VULNERABILITY_MANAGEMENT_UPLOAD_NESSUS_REQUESTED,
    VULNERABILITY_TASK_CATEGORIES_SUCCESSED,
    VULNERABILITY_TASK_CATEGORIES_FAILED,
    VULNERABILITY_TASK_CATEGORIES_REQUESTED,
    VULNERABILITY_DELETE_ATTACHMENT_REQUESTED,
    VULNERABILITY_DELETE_ATTACHMENT_SUCCESSED,
    VULNERABILITY_DELETE_ATTACHMENT_FAILED,
    VULNERABILITY_MANAGEMENT_OPEN_CASES_REQUESTED,
    VULNERABILITY_MANAGEMENT_OPEN_CASES_SUCCESSED,
    VULNERABILITY_MANAGEMENT_OPEN_CASES_FAILED,
    VULNERABILITY_MANAGEMENT_CASE_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_CASE_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_CASE_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_UPDATE_SUCCESSED,
    VULNERABILITY_MANAGEMENT_UPDATE_FAILED,
    VULNERABILITY_MANAGEMENT_UPDATE_REQUESTED,
    VULNERABILITY_VULNERABILITY_ASSET_SUCCESSED,
    VULNERABILITY_VULNERABILITY_ASSET_FAILED,
    VULNERABILITY_VULNERABILITY_ASSET_REQUESTED,
    VULNERABILITY_SEARCH_BY_NAME_ASSET_REQUESTED,
    VULNERABILITY_SEARCH_BY_NAME_ASSET_SUCCESSED,
    VULNERABILITY_SEARCH_BY_NAME_ASSET_FAILED,
    ASSESSMENT_TEMPLATE_CREATE_FAILED,
    ASSESSMENT_TEMPLATE_CREATE_REQUESTED,
    ASSESSMENT_TEMPLATE_CREATE_SUCCESSED,
    VULNERABILITY_FIELD_EDITOR_IMAGE_REQUESTED,
    VULNERABILITY_FIELD_EDITOR_IMAGE_SUCCESSED,
    VULNERABILITY_FIELD_EDITOR_IMAGE_FAILED,
    VULNERABILITY_TASK_DEPARTMENT_REQUESTED,
    VULNERABILITY_TASK_DEPARTMENT_SUCCESSED,
    VULNERABILITY_TASK_DEPARTMENT_FAILED,
    VULNERABILITY_MANAGEMENT_NAME_LIST_REQUESTED,
    VULNERABILITY_MANAGEMENT_NAME_LIST_SUCCESSED,
    VULNERABILITY_MANAGEMENT_NAME_LIST_FAILED,
    VULNERABILITY_MANAGEMENT_CONTENT_REQUESTED,
    VULNERABILITY_MANAGEMENT_CONTENT_SUCCESSED,
    VULNERABILITY_MANAGEMENT_CONTENT_FAILED,
    VULNERABILITY_MANAGEMENT_EDIT_SEARCH_REQUESTED,
    VULNERABILITY_MANAGEMENT_EDIT_SEARCH_SUCCESSED,
    VULNERABILITY_MANAGEMENT_EDIT_SEARCH_FAILED
} from '../../constants/actionTypes';
import {
    vulnerabilityListAPI,
    vulnerabilityByIdAPI,
    vulnerabilityAssessmentListAPI,
    vulnerabilityListDeleteAPI,
    vulnerabilityAssessmentListDeleteAPI,
    generateReportValAssessmentAPI,
    templateListAssessmentAPI,
    exportExcel,
    exportPDF,
    bulkUpdateValnerabilityAPI,
    attackType,
    attackTypeListVulnerability,
    assetListVulnerability,
    severityListVulnerability,
    vulnerabilityLogList,
    initiatemanualAssessment,
    initiatemanualAssessmentuUpdate,
    vulnerabilitylistUpdate,
    vulnerabilityAddAsset,
    vulnerabilityAssetDelete,
    vulnerabilityAssessmentApplicationList,
    vulnerabilityAssessmentActionList,
    executeInitiateManualActionList,
    deleteMultiValnerabilityActionList,
    getValnerabilityAssessmentsAPI,
    addAssessmentVulnerabilityAPI,
    deleteAssessmentVulnerabilityAPI,
    importAssessmentAPI,
    updateVulnerabilityManagementApi,
    addTaskVulnerabilityManagement,
    viewTaskVulnerabilityManagement,
    vulnerabilitiesComment,
    viewTaskVulnerabilityUploadNessus,
    vulnerabilityTemplateType,
    vulnerabilityTaskCategories,
    vulnerabilityDeleteAttachment,
    updatePartialVulnerabilityManagementApi,
    vulnerabilityCreateCases,
    vulnerabilityCaseList,
    vulnerabilityAsset,
    vulnerabilitySearchAsset,
    templateCreateAssessmentAPI,
    vulnerabilityFeildEditorUploadImage,
    vulnerabilityTaskDepartments,
    vulnerabilityManagementNameList,
    vulnerabilityContent,
    vulnerabilityCveSearch
} from '../../api/vulnerabilityManagement';
import { assessmentListAction, getVulnerabilityDetail, vulnerabilityAssetRequest, vulnerabilityListAction } from '../../actions/vulnerabilityManagement';

const moduleName = 'vulnerability';
export function* watchVulnerabilityList(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityListAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_GET_LIST_SUCCESSED,
                data: response
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_GET_LIST_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchVulnerabilityDeleteList(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityListDeleteAPI, action.id);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_DELETE_LIST_SUCCESSED,
                data: response
            });
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Vulnerability Deleted Successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_DELETE_LIST_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchVulnerabilityUpdateList(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilitylistUpdate, action.id, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_UPDATE_SUCCESSED,
                data: response
            });
            yield put(getVulnerabilityDetail({ id: action?.id }));
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Vulnerability Updated Successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
            if (action?.isDetail) {
                yield put(getVulnerabilityDetail({ id: action?.id }));
            }
            if (action?.assessmentId) {
                yield put(vulnerabilityAssetRequest(action.assessmentId));
            }
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_UPDATE_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}


export function* watchBulkUpdate(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(bulkUpdateValnerabilityAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_BULK_UPDATE_SUCCESSED,
                data: response?.data,
            });
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Records updated successfully!',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
            yield put(
                vulnerabilityListAction({ queryItem: action.query })
            );
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'Something Went Wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({ type: VULNERABILITY_MANAGEMENT_BULK_UPDATE_FAILED, data: err });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchAttackType() {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(attackTypeListVulnerability);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ATTACK_TYPE_SUCCESSED,
                data: response.data
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_ATTACK_TYPE_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchAssetType() {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(assetListVulnerability);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSET_TYPE_SUCCESSED,
                data: response.data
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSET_TYPE_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}
export function* watchSeverityList() {
    try {
        yield put({type: HIDE_LOADER});
        const response = yield call(severityListVulnerability);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_SEVERITY_SUCCESSED,
                data: response.data
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_SEVERITY_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}
export function* watchApplicationList() {
    try {
        yield put({type: SHOW_LOADER});
        const response = yield call(vulnerabilityAssessmentApplicationList);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_APPLICATION_LIST_SUCCESSED,
                data: response.data
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_APPLICATION_LIST_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}
export function* watchVulnerabilityActionList(action) {
    try {
        yield put({type: SHOW_LOADER});
        const response = yield call(vulnerabilityAssessmentActionList, action.id);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_ACTIONS_LIST_SUCCESSED,
                data: response.data
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_ACTIONS_LIST_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchVulnerabilityById(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityByIdAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: GET_VULNERABLITY_MANAGEMENT_BY_ID_SUCCESSED,
                data: response.data
            });
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({
            type: GET_VULNERABLITY_MANAGEMENT_BY_ID_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchPDFExport(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(exportPDF, action?.payload);
        if (response.success === true) {
            yield put({ type: VULNERABILITY_EXPORT_PDF_LIST_SUCCESSED, data: response?.data });
        }
        yield put({ type: HIDE_LOADER });
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'PDF downloaded.',
                feedbackType: 'success',
                module: moduleName,
            },
        });
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'Something Went Wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({ type: HIDE_LOADER });
        yield put({
            type: VULNERABILITY_EXPORT_PDF_LIST_FAILED,
            data: err?.response?.data?.data,
        });
    }
}
export function* watchExcelExport(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(exportExcel, action.payload);
        if (response.success === true) {
            yield put({ type: VUNERABILITY_EXPORT_EXCEL_LIST_SUCCESSED, data: response?.data });
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Excel downloaded.',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VUNERABILITY_EXPORT_EXCEL_LIST_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({ type: HIDE_LOADER });
    }
}

export function* watchVulnerabilityAddAsset(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityAddAsset, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ADD_ASSET_SUCCESSED,
                data: response
            });
            yield put(vulnerabilityAssetRequest(action.payload.vua_assesment_id))
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Asset Added Successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_ADD_ASSET_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchVulnerabilityAssessmentList(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityAssessmentListAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_GET_LIST_SUCCESSED,
                data: response
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_GET_LIST_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchVulnerabilityAssetDeleteRequest(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityAssetDelete, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_DELETE_ASSET_SUCCESSED,
                data: response
            });
            yield put(vulnerabilityAssetRequest(action.payload.asses_id));
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Asset Deleted Successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_DELETE_ASSET_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}

export function* watchVulnerabilityExecuteList(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(executeInitiateManualActionList, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_EXECUTE_LIST_SUCCESSED,
                data: response
            });
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Automation-Playground Create',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_EXECUTE_LIST_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}


export function* watchVulnerabilityAssessmentDeleteList(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityAssessmentListDeleteAPI, action.id);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_LIST_SUCCESSED,
                data: response
            });
            yield put(assessmentListAction({ queryItem: action.query }));
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Vulnerability Assessment Deleted Successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_LIST_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}
export function* watchGenerateTemplate(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(generateReportValAssessmentAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_GENERATE_REPORTS_SUCCESSED,
                data: response
            });
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Report Generated',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({ type: HIDE_LOADER });
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_GENERATE_REPORTS_FAILED,
            data: err?.response?.data?.data,
        });
    }
}
export function* watchTemplateList(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(templateListAssessmentAPI, action.id);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_TEMPLATE_LIST_SUCCESSED,
                data: response?.data
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_TEMPLATE_LIST_FAILED,
            data: err?.response?.data?.data,
        });
    }
}
export function* watchAssessmentCreateTemplate(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(templateCreateAssessmentAPI, action.payload);
        if (response.success === true) {
            yield put({ type: ASSESSMENT_TEMPLATE_CREATE_SUCCESSED, data: response?.data });
        } else {
            yield put({ type: ASSESSMENT_TEMPLATE_CREATE_FAILED, data: null });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({ type: ASSESSMENT_TEMPLATE_CREATE_FAILED, data: err?.response?.data?.data });
        yield put({type: HIDE_LOADER});
    }
}
export function* watchAssessmentLogList(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityLogList, action.id);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_LOGS_SUCCESSED,
                data: response?.data
            });
        }
        yield put({type: HIDE_LOADER});
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_LOGS_FAILED,
            data: err?.response?.data?.data,
        });
        yield put({type: HIDE_LOADER});
    }
}
export function* watchInitialManualAssessment(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(initiatemanualAssessment, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_CREATE_SUCCESSED,
                data: response?.data
            });
            yield put(assessmentListAction({ queryItem: action.query }));
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'assessment_create_success',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({ type: HIDE_LOADER });
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_CREATE_FAILED,
            data: err?.response?.data?.data,
        });
    }
}
export function* watchInitialManualAssessmentUpdate(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(initiatemanualAssessmentuUpdate, action.id, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_UPDATE_SUCCESSED,
                data: response?.data
            });
            yield put(assessmentListAction({ queryItem: action.query }));
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'assessment_update_success',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({ type: HIDE_LOADER });
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_UPDATE_FAILED,
            data: err?.response?.data?.data,
        });
    }
}


export function* watchDeleteMultiDeleteVulnerability(action) {
    try {
        const response = yield call(deleteMultiValnerabilityActionList, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_MULTI_DELETE_LIST_SUCCESSED,
                data: response
            });
        }
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_MULTI_DELETE_LIST_FAILED,
            data: err?.response?.data?.data,
        });
    }
}

export function* watchGetVulnerability(action) {
    try {
        const response = yield call(getValnerabilityAssessmentsAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_GET_SINGLE_ASSESSMENT_SUCCESSED,
                data: response?.data
            });
        }
    } catch (err) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_GET_SINGLE_ASSESSMENT_FAILED,
            data: err?.response?.data?.data,
        });
    }
}

export function* watchAddAssessmentVulnerabilty(action) {
    try {
        const response = yield call(addAssessmentVulnerabilityAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_ADD_VULNERABILITY_SUCCESSED,
                data: response?.data
            });
            yield put(vulnerabilityAssetRequest(action.assessmentId));
            const message = response?.data;
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: message || 'Vunlnerability Added',
                    feedbackType: "success",
                    module: moduleName,
                },
            });
        }
    } catch (e) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_ADD_VULNERABILITY_FAILED,
            data: err?.response?.data?.data,
        });
    }
}

export function* watchImportAssessment(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(importAssessmentAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_IMPORT_SUCCESSED,
                data: response?.data
            });
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'File Imported Successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
            action.history.push('/vulnerabilityManagement/assessments/import/mapFields')

        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({ type: HIDE_LOADER });
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'Something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_IMPORT_FAILED,
            data: err?.response?.data?.data,
        });
    }
}

export function* watchDeleteAssessmentVulnerabilty(action) {
    try {
        const response = yield call(deleteAssessmentVulnerabilityAPI, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_VULNERABILITY_SUCCESSED,
                data: response?.data
            });
            yield put(vulnerabilityAssetRequest(action.payload.asses_id));
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Vulnerability is deleted successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        } else {
            yield put({
                type: VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_VULNERABILITY_FAILED,
                data: err?.response?.data?.data,
            });
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'something went wrong',
                    feedbackType: 'error',
                    module: moduleName,
                },
            });
        }
    } catch (e) {
        yield put({
            type: SET_FEEDBACK_ALERT,
            payload: {
                feedbackMessage: 'something went wrong',
                feedbackType: 'error',
                module: moduleName,
            },
        });
        yield put({
            type: VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_VULNERABILITY_FAILED,
            data: err?.response?.data?.data,
        });
    }
}


export function* watchUpdatePartialVulnerability(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(updatePartialVulnerabilityManagementApi, action?.payload);
        if (response.success) {
            const key = Object.keys(action?.payload.data);

            yield put({
                type: UPDATE_PARTIAL_VULNERABILITY_MANAGEMENT_SUCCESSED,
                data: response?.data,
            });
            const msg = `Vulnerability Updated`;
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: msg,
                    feedbackType: 'success',
                    module: 'VulnerabilityManagement',
                },
            });
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({ type: UPDATE_PARTIAL_VULNERABILITY_MANAGEMENT_FAILED, data: err });
    }
}

export function* watchAddTaskVulnerability(action) {
    try {
        const response = yield call(addTaskVulnerabilityManagement, action?.payload);
        if (response.success === true) {
            yield put({
                type: ADD_TASK_VULNERABILITY_MANAGEMENT_SUCCESSED,
                data: response.data,
            });
        }
    } catch (err) {
        yield put({ type: ADD_TASK_VULNERABILITY_MANAGEMENT_FAILED, data: err });
    }
}
export function* watchViewTaskVulnerability(action) {
    try {
        const response = yield call(viewTaskVulnerabilityManagement, action?.payload);
        if (response.success === true) {
            yield put({
                type: VIEW_TASK_VULNERABILITY_MANAGEMENT_SUCCESSED,
                data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VIEW_TASK_VULNERABILITY_MANAGEMENT_FAILED, data: err });
    }
}
export function* watchAddCommentValnerability(action) {
    try {
        const response = yield call(vulnerabilitiesComment, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_COMMENT_SUCCESSED,
                data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_MANAGEMENT_COMMENT_FAILED, data: err });
    }
}
export function* watchValnerabilityNessusUpload(action) {

    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(viewTaskVulnerabilityUploadNessus, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_UPLOAD_NESSUS_SUCCESSED,
                data: response?.data,

            })
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'File Uploaded Successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
            action.history.push('/vulnerabilityManagement/assessments')

        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({ type: VULNERABILITY_MANAGEMENT_UPLOAD_NESSUS_FAILED, data: err });
    }
}

export function* watchTemplateTypeList() {

    try {
        const response = yield call(vulnerabilityTemplateType);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_TEMPLATE_TYPE_SUCCESSED,
                data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_MANAGEMENT_TEMPLATE_TYPE_FAILED, data: err });
    }
}

// Task Categories
export function* watchTaskCategories(action) {
    try {
        const response = yield call(vulnerabilityTaskCategories);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_TASK_CATEGORIES_SUCCESSED,
                data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_TASK_CATEGORIES_FAILED, data: err });
    }
}

export function* watchTaskDepartments(action) {
    try {
        const response = yield call(vulnerabilityTaskDepartments);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_TASK_DEPARTMENT_SUCCESSED,
                data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_TASK_DEPARTMENT_FAILED, data: err });
    }
}

// Watch Delete Attachment
export function* watchDeleteAttachment(action) {
    try {
        const response = yield call(vulnerabilityDeleteAttachment, action.id, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_DELETE_ATTACHMENT_SUCCESSED,
                data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_DELETE_ATTACHMENT_FAILED, data: err });
    }
}
export function* watchCreateCases(action) {
    try {
        yield put({ type: SHOW_LOADER });
        const response = yield call(vulnerabilityCreateCases, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_OPEN_CASES_SUCCESSED,
                data: action?.payload?.data,
            })
            yield put({
                type: SET_FEEDBACK_ALERT,
                payload: {
                    feedbackMessage: 'Cases Created Successfully',
                    feedbackType: 'success',
                    module: moduleName,
                },
            });
        }
        yield put({ type: HIDE_LOADER });
    } catch (err) {
        yield put({ type: HIDE_LOADER });
        yield put({ type: VULNERABILITY_MANAGEMENT_OPEN_CASES_FAILED, data: err });
    }
}

export function* watchvulnerabilityCasesList() {
    try {
        const response = yield call(vulnerabilityCaseList);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_CASE_LIST_SUCCESSED, data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_MANAGEMENT_CASE_LIST_FAILED, data: err });
    }
}
export function* watchvulnerabilityAssetRequest(action) {
    try {
        const response = yield call(vulnerabilityAsset, action.id);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_VULNERABILITY_ASSET_SUCCESSED, data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_VULNERABILITY_ASSET_FAILED, data: err });
    }
}
export function* watchvulnerabilitySearchByNameAsset(action) {
    try {
        const response = yield call(vulnerabilitySearchAsset, action.searchValue);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_SEARCH_BY_NAME_ASSET_SUCCESSED, data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_SEARCH_BY_NAME_ASSET_FAILED, data: err });
    }
}
//Feild Editor Image Upload
export function* watchvulnerabilityFeildEditorUploadImage(action) {
    try {
        const response = yield call(vulnerabilityFeildEditorUploadImage, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_FIELD_EDITOR_IMAGE_SUCCESSED, data: response?.data
            })
        }
    } catch (err) {
        yield put({
            type: VULNERABILITY_FIELD_EDITOR_IMAGE_FAILED, data: err
        })
    }
}

export function* watchvulnerabilityNameList() {
    try {
        const response = yield call(vulnerabilityManagementNameList);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_NAME_LIST_SUCCESSED, data: response?.data,
            })
        }
    } catch (err) {
        yield put({ type: VULNERABILITY_MANAGEMENT_NAME_LIST_FAILED, data: err });
    }
}
//vulnerabilityContent vulnerabilityCveSearch
export function* watchvulnerabilityContentList(action) {
    try {
        const response = yield call(vulnerabilityContent, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_CONTENT_SUCCESSED, data: response?.data
            })
        }
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_CONTENT_FAILED, data: err
        })
    }
}
export function* watchvulnerabilityEditSearch(action) {
    try {
        const response = yield call(vulnerabilityCveSearch, action.payload);
        if (response.success === true) {
            yield put({
                type: VULNERABILITY_MANAGEMENT_EDIT_SEARCH_SUCCESSED, data: response?.data
            })
        }
    } catch (err) {
        yield put({
            type: VULNERABILITY_MANAGEMENT_EDIT_SEARCH_FAILED, data: err
        })
    }
}

export default function* watcher() {
    yield takeLatest(VULNERABILITY_MANAGEMENT_GET_LIST_REQUESTED, watchVulnerabilityList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_DELETE_LIST_REQUESTED, watchVulnerabilityDeleteList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ATTACK_TYPE_REQUESTED, watchAttackType);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSET_TYPE_REQUESTED, watchAssetType);
    yield takeLatest(VULNERABILITY_MANAGEMENT_BULK_UPDATE_REQUESTED, watchBulkUpdate);
    yield takeLatest(VULNERABILITY_MANAGEMENT_SEVERITY_REQUESTED, watchSeverityList);
    yield takeLatest(GET_VULNERABLITY_MANAGEMENT_BY_ID_REQUESTED, watchVulnerabilityById);
    yield takeLatest(VULNERABILITY_EXPORT_PDF_LIST_REQUESTED, watchPDFExport);
    yield takeLatest(VUNERABILITY_EXPORT_EXCEL_LIST_REQUESTED, watchExcelExport);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_GET_LIST_REQUESTED, watchVulnerabilityAssessmentList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_LIST_REQUESTED, watchVulnerabilityAssessmentDeleteList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_GENERATE_REPORTS_REQUESTED, watchGenerateTemplate);
    yield takeLatest(VULNERABILITY_MANAGEMENT_TEMPLATE_LIST_REQUESTED, watchTemplateList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_LOGS_REQUESTED, watchAssessmentLogList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_UPDATE_REQUESTED, watchInitialManualAssessmentUpdate);
    yield takeLatest(VULNERABILITY_MANAGEMENT_INTIAL_MANUAL_ASSESSMENT_CREATE_REQUESTED, watchInitialManualAssessment);
    yield takeLatest(VULNERABILITY_MANAGEMENT_UPDATE_REQUESTED, watchVulnerabilityUpdateList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ADD_ASSET_REQUESTED, watchVulnerabilityAddAsset);
    yield takeLatest(VULNERABILITY_MANAGEMENT_DELETE_ASSET_REQUESTED, watchVulnerabilityAssetDeleteRequest);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_APPLICATION_LIST_REQUESTED, watchApplicationList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_ACTIONS_LIST_REQUESTED, watchVulnerabilityActionList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_EXECUTE_LIST_REQUESTED, watchVulnerabilityExecuteList);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_MULTI_DELETE_LIST_REQUESTED, watchDeleteMultiDeleteVulnerability);
    yield takeLatest(VULNERABILITY_MANAGEMENT_GET_SINGLE_ASSESSMENT_REQUESTED, watchGetVulnerability);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_ADD_VULNERABILITY_REQUESTED, watchAddAssessmentVulnerabilty);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_IMPORT_REQUESTED, watchImportAssessment);
    yield takeLatest(VULNERABILITY_MANAGEMENT_ASSESSMENT_DELETE_VULNERABILITY_REQUESTED, watchDeleteAssessmentVulnerabilty)
    yield takeLatest(UPDATE_PARTIAL_VULNERABILITY_MANAGEMENT_REQUESTED, watchUpdatePartialVulnerability)
    yield takeLatest(ADD_TASK_VULNERABILITY_MANAGEMENT_REQUESTED, watchAddTaskVulnerability)
    yield takeLatest(VIEW_TASK_VULNERABILITY_MANAGEMENT_REQUESTED, watchViewTaskVulnerability)
    yield takeLatest(VULNERABILITY_MANAGEMENT_COMMENT_REQUESTED, watchAddCommentValnerability)
    yield takeLatest(VULNERABILITY_MANAGEMENT_UPLOAD_NESSUS_REQUESTED, watchValnerabilityNessusUpload)
    yield takeLatest(VULNERABILITY_MANAGEMENT_TEMPLATE_TYPE_REQUESTED, watchTemplateTypeList)
    yield takeLatest(VULNERABILITY_TASK_CATEGORIES_REQUESTED, watchTaskCategories)
    yield takeLatest(VULNERABILITY_DELETE_ATTACHMENT_REQUESTED, watchDeleteAttachment)
    yield takeLatest(VULNERABILITY_MANAGEMENT_OPEN_CASES_REQUESTED, watchCreateCases)
    yield takeLatest(VULNERABILITY_MANAGEMENT_CASE_LIST_REQUESTED, watchvulnerabilityCasesList);
    yield takeLatest(VULNERABILITY_VULNERABILITY_ASSET_REQUESTED, watchvulnerabilityAssetRequest);
    yield takeLatest(VULNERABILITY_SEARCH_BY_NAME_ASSET_REQUESTED, watchvulnerabilitySearchByNameAsset);
    yield takeLatest(ASSESSMENT_TEMPLATE_CREATE_REQUESTED, watchAssessmentCreateTemplate)
    yield takeLatest(VULNERABILITY_FIELD_EDITOR_IMAGE_REQUESTED, watchvulnerabilityFeildEditorUploadImage)
    yield takeLatest(VULNERABILITY_TASK_DEPARTMENT_REQUESTED, watchTaskDepartments)
    yield takeLatest(VULNERABILITY_MANAGEMENT_NAME_LIST_REQUESTED, watchvulnerabilityNameList)
    yield takeLatest(VULNERABILITY_MANAGEMENT_CONTENT_REQUESTED, watchvulnerabilityContentList)
    yield takeLatest(VULNERABILITY_MANAGEMENT_EDIT_SEARCH_REQUESTED, watchvulnerabilityEditSearch)

}
//watchvulnerabilityEditSearch